import {
  type ProductMediaAssetFormat,
  type ThumbnailFormat,
} from '@/modules/product/types';

export function getSmallestProductPictureFormat(
  formats: ProductMediaAssetFormat
): ThumbnailFormat {
  return [...Object.values(formats)].sort((a, b) => {
    if (a.width < b.width) {
      return -1;
    }
    if (a.width === b.width) {
      return 0;
    }
    return 1;
  })[0];
}
